import { useCallback } from 'react';
import type { KeyboardEvent, RefObject } from 'react';

import type { CropperImage } from 'cropperjs';

const ARROW_KEY_OFFSETS = new Map<string, [number, number]>([
	['ArrowLeft', [-1, 0]],
	['ArrowRight', [1, 0]],
	['ArrowDown', [0, 1]],
	['ArrowUp', [0, -1]],
]);

type Props = {
	imageRef: RefObject<CropperImage | null>;
	disabled: boolean;
};

/** Nudges the image by 1px per arrow key press. */
export function useCropperKeyboard({ imageRef, disabled }: Props): (event: KeyboardEvent<HTMLDivElement>) => void {
	return useCallback(
		(event: KeyboardEvent<HTMLDivElement>) => {
			const offset = ARROW_KEY_OFFSETS.get(event.key);
			if (disabled || !offset) return;
			event.preventDefault();
			imageRef.current?.$move(...offset);
		},
		[disabled, imageRef],
	);
}
